import { Flex } from "antd"
import BookingDetails from "ui/Booking/Details"
import IconWithBg from "ui/IconWithBg"
import { LeftOutlined } from "@ant-design/icons"
import { useNavigate, useParams } from "react-router-dom"
import { useDispatch } from "react-redux"
import { getClientBookingDetails } from "store/bookings"
import { useEffect } from "react"

const BookingDetailsPage = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { id } = useParams()

  const handleBackToBookings = () => {
    navigate(-1)
  }

  useEffect(() => {
    dispatch(getClientBookingDetails(id))
  }, [id, dispatch])

  return (
    <Flex vertical className="mt-m">
      <IconWithBg icon={<LeftOutlined />} onClick={handleBackToBookings} />
      <BookingDetails isShowTitle={false} />
    </Flex>
  )
}

export default BookingDetailsPage
